<template>
  <div
    :class="[
      $style.marketingBanner,
      gradientBackground && !greenGradient && $style.gradientBackground,
      greenGradient && 'bg-gradient-green-dark box-border flex flex-col min-h-[296px]',
      bgImage && $style.backgroundImage,
    ]"
    :style="[{'background-image': bgImage && `url(${bgImage})` }]"
  >
    <b-svg
      v-if="svgTop"
      :name="svgTop"
      :class="[
        svgTopBoxClass,
        light && 'text-white text-shadow-2xs',
        greenGradient ? 'mb-2' : 'mb-4',
      ]"
      :size="svgTopSize"
    />

    <div class="flex mb-3">
      <div class="mr-4">
        <div
          v-if="title"
          :class="[
            greenGradient ? 'text-xl font-bold leading-7 pb-2' : $style.title,
            light && 'text-white text-shadow-2xs',
          ]"
        >
          {{ title }}
        </div>
        <div
          v-if="description"
          :class="[
            'b-font-h6',
            light && 'text-white text-shadow-2xs',
          ]"
        >
          {{ description }}
        </div>
      </div>
      <b-svg
        v-if="svgRight"
        :name="svgRight"
        class="min-w-20 max-w-20 ml-auto"
        :size="80"
      />
      <img
        v-if="imageRight"
        width="80"
        height="80"
        class="ml-auto"
        :src="imageRight"
      />
    </div>

    <div
      v-if="greenGradient"
      class="mt-auto"
    >
      <slot name="buttons"/>
    </div>
    <slot
      v-else
      name="buttons"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'b-marketing-banner',
})

const SVG_TOP_BOX_CLASS_BY_SIZE: Record<number, string> = {
  32: 'min-w-8 max-w-8',
  36: 'min-w-9 max-w-9',
  80: 'min-w-20 max-w-20',
}

const props = withDefaults(
  defineProps<{
    title?: string | null
    description?: string | null
    gradientBackground?: boolean
    greenGradient?: boolean
    light?: boolean
    bgImage?: string | null
    svgTop?: string | null
    svgTopSize?: number
    svgRight?: string | null
    imageRight?: string | null
  }>(),
  {
    title: null,
    description: null,
    gradientBackground: false,
    greenGradient: false,
    light: false,
    bgImage: null,
    svgTop: null,
    svgTopSize: 80,
    svgRight: null,
    imageRight: null,
  }
)

const svgTopBoxClass = computed(() => {
  const mappedClass = SVG_TOP_BOX_CLASS_BY_SIZE[props.svgTopSize]

  if (mappedClass) {
    return mappedClass
  }

  return `min-w-[${props.svgTopSize}px] max-w-[${props.svgTopSize}px]`
})
</script>

<style lang="scss" module>
@layer legacy-views {

.marketingBanner {
  border-radius: 8px;
  padding: 16px;
  background-color: var(--color-bg-primary);

  .title {
    font-weight: 600;
    padding-bottom: 4px;
  }
}

.gradientBackground {
  background: var(--b-gradient-purple)
}

.backgroundImage {
  background-repeat: no-repeat;
  background-position: right top;
}

}</style>
